import script from "./StudentAnalysisPages.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentAnalysisPages.vue?vue&type=script&setup=true&lang=ts"

import "./StudentAnalysisPages.vue?vue&type=style&index=0&id=09b490b4&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b490b4"]])

export default __exports__